<template>
  <div id="app">
    <!-- Desktop Navbar (only visible on desktop and when not showing session messages) -->
    <DesktopNavbar v-if="isDesktop && shouldShowNavbar" />

    <!-- Main Content Area -->
    <div
      class="main-content"
      :class="{ 'with-navbar': isDesktop && shouldShowNavbar }"
    >
      <router-view />
    </div>
  </div>
</template>

<script>
import DesktopNavbar from "@/components/DesktopNavbar.vue";

export default {
  name: "App",
  components: {
    DesktopNavbar,
  },
  data() {
    return {
      isDesktop: false,
    };
  },
  computed: {
    shouldShowNavbar() {
      // Hide navbar if we're on login page and user is not authenticated
      // This covers session invalid, logout, and other authentication failure scenarios
      if (this.$route.name === "login") {
        return false; // Always hide navbar on login page
      }
      return true;
    },
  },
  mounted() {
    this.checkScreenSize();
    window.addEventListener("resize", this.checkScreenSize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkScreenSize);
  },
  methods: {
    checkScreenSize() {
      this.isDesktop = window.innerWidth >= 1024;
    },
  },
};
</script>

<style>
#app {
  font-family: "Open Sans", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.main-content {
  min-height: 100vh;
  transition: margin-left 0.3s ease;
}

.main-content.with-navbar {
  padding-top: 70px;
}

/* Responsive adjustments */
@media (max-width: 1024px) {
  .main-content.with-navbar {
    padding-top: 0;
  }
}
</style>
